/**
 * How much a person may put in one question.
 *
 * It was 500, enforced twice: `maxLength` on the composer and `.max(500)` on
 * the route. The composer's was the damaging one. `maxLength` does not reject a
 * paste, it truncates it — so a representative who pasted four and a half
 * thousand characters of another school's proposals got the first five hundred,
 * silently, with no counter, no warning and no scrollbar to suggest anything
 * was missing. The question that reached the model stopped mid-sentence at
 * "Current Tyndale Step 5", which is also why it answered badly: it was handed
 * a bare pay scale with the question cut off the end of it, reached for the
 * public Award to make sense of the numbers, and was refused by the citation
 * guard for doing so.
 *
 * Six thousand, because the thing people actually paste is a page or two of
 * somebody else's claims — which is a real and reasonable use of this surface,
 * not an abuse of it. Past that there is a document upload beside the box, and
 * the message says so rather than leaving a person to guess.
 *
 * The number lives here so the two ends cannot drift apart. They already had:
 * the route would have accepted anything the composer could send, so the server
 * limit had never once been the thing a person hit.
 */
export const MAX_QUESTION = 6000;
/**
 * The length past which a question is condensed before it is embedded.
 *
 * Retrieval embeds the question to find clauses. A two-page paste embedded whole
 * is mostly other people's prose, and the vector lands in the middle of
 * everything and near nothing — the longer the paste, the worse the clauses that
 * come back, which is the opposite of what a person pasting more context
 * expects. Past this length the question is rewritten into a retrievable one
 * first; below it, the teacher's own words are already the best query.
 */
export const CONDENSE_OVER = 600;
//# sourceMappingURL=ask.js.map